import { change, arrayPush } from 'redux-form';
import { get, map, omit, isEmpty } from 'lodash';
import {
  fetchInventory,
  createInventory,
  updateInventoryItem
} from '../../../../app-main/actions/inventory';
import { ADD_ITEMS_FORM } from '../constants/formNames';
import { toggleBanner } from '../../../actions/banner';


const generatePayload = (values, props) => {
  const { isVatEnabled = false } = props;
  const spaceId = get(props, 'spaceId');
  const ssoId = get(props, 'profile.SSOid');
  const nonVatTaxTypes = get(props, 'nonVatTaxTypes', []);
  const addOnImgIds = get(props, 'addOnImgId').length ?
    [props.addOnImgId]
    :
    [];

  const {
    label,
    category,
    subcategory,
    description,
    unit_cost,
    unit_cost_basis,
    count,
    visible_on_listing,
    taxes = [],
    fees = []
  } = values;

  const taxAndFees = [...taxes, ...fees];
  const additionalCharges = map(taxAndFees, charge => {
    if ('%' === charge.charge_unit) {
      return {
        ...charge,
        amount: Number(charge.amount) / 100
      };
    }

    return {
      ...charge,
      amount: Number(charge.amount)
    };
  });

  const vatFees = map(fees, charge => {
    if ('%' === charge.charge_unit) {
      return {
        ...charge,
        amount: Number(charge.amount) / 100
      };
    }

    return {
      ...charge,
      amount: Number(charge.amount)
    };
  });

  const vatTaxes = map(taxes, charge => {
    if ('%' === charge.charge_unit) {
      const chargeLabel = charge.label;
      const includedNonVatTaxTypes = map(nonVatTaxTypes, (taxType) => {
        return taxType.label === chargeLabel.toLowerCase();
      });

      const isVat = isEmpty(includedNonVatTaxTypes);
      const chargeType = isVat ? 'included_vat' : 'tax';
      const taxLabel = 'other' === chargeLabel.toLowerCase() ?
        charge.other_label : chargeLabel;

      return {
        ...omit(charge, 'other_label'),
        amount: Number(charge.amount) / 100,
        charge_type: chargeType,
        label: taxLabel
      };
    }

    return {
      ...charge,
      amount: Number(charge.amount)
    };
  });

  const additionalChargesValue = isVatEnabled ?
    [...vatTaxes, ...vatFees] : additionalCharges;

  const payload = {
    space_id: spaceId,
    additional_charges: additionalChargesValue,
    unit_cost_basis,
    sso_id: ssoId,
    label,
    unit_cost: Number(unit_cost),
    description,
    category,
    subcategory,
    visible_on_listing: 'true' === visible_on_listing,
    image_ids: addOnImgIds,
    count: Number(count) || 0
  };

  return { ...payload };
};

const submitCreateAddOnForm = (values, dispatch, props) => {
  const {
    spaceId,
    add_ons,
    auth,
    changeSubmitPhotoState = null,
    submitPhoto = false
  } = props;

  const itemIndex = get(add_ons, 'index');
  const payload = generatePayload(values, props);
  const accessToken = get(auth, 'accessToken');
  const omitAddonResponse = ['statusCode', 'group_id', 'modified'];

  if (props.isEditAddOnModal) {
    const itemId = values._id;
    return dispatch(updateInventoryItem(payload, itemId, accessToken, response => {
      if (200 === response.statusCode) {
        const { currency = {}, ...restOfValues } = omit(response, omitAddonResponse);
        const analyticsData = {
          currency_symbol: currency.symbol,
          currency_type: currency.code,
          ...restOfValues
        };

        analyticsIntegrations.createItemFormSubmitted(analyticsData, true, props.fromManageAddons);

        if (0 === itemIndex || itemIndex) {
          const enteredCount = props.addItemsForm[itemIndex].count;
          const unitCost = get(response, 'unit_cost', 0);

          dispatch(change(
            'ADD_ITEMS_FORM',
            `addOns[${itemIndex}]`,
            { ...response,
              title: itemId,
              count: Number(enteredCount),
              unit_cost: unitCost.toFixed(2)
            }
          ));
        }

        if (!submitPhoto) {
          props.toggleModal();
          dispatch(toggleBanner('addonsEditSuccess'));
          dispatch(fetchInventory(spaceId, accessToken));
        }

        changeSubmitPhotoState();
      }
    }));
  }

  dispatch(createInventory(payload, accessToken, response => {
    if (200 === response.statusCode) {
      props.toggleModal();
      dispatch(toggleBanner('addonsSaveSuccess'));
      const itemId = response._id;
      const { currency = {}, ...restOfValues } = omit(response, omitAddonResponse);
      const analyticsData = {
        currency_symbol: currency.symbol,
        currency_type: currency.code,
        ...restOfValues
      };
      payload.item_id = itemId;
      analyticsIntegrations.createItemFormSubmitted(analyticsData, false, props.fromManageAddons);

      dispatch(fetchInventory(spaceId, accessToken, resp => {
        if (200 === resp.statusCode) {
          if (null !== itemIndex) {
            const unitCost = get(response, 'unit_cost', 0);

            dispatch(change(
              'ADD_ITEMS_FORM',
              `addOns[${itemIndex}]`,
              { ...response,
                title: itemId,
                count: '',
                unit_cost: unitCost.toFixed(2)
              }
            ));
          }
        }

        arrayPush(ADD_ITEMS_FORM, {
          ...response,
          title: itemId
        });
        // need to add error handling
      }));
    }
  }));
};

export default submitCreateAddOnForm;
